import { z } from 'zod';
export var ActionTypeArray = [
    'CLOSE_MODAL',
    'OPEN_MODAL',
    'SHOW_PAYWALL',
    'HIDE_PAYWALL',
    'SHOW_GLOBAL_LOADER',
    'HIDE_GLOBAL_LOADER',
    'UPDATE_FORM_STATE',
    'UPDATE_COMPANY_STORE',
    'LOGIN',
    'LOGOUT',
    'ADD_PRODUCT',
    'UPDATE_ACCOUNT',
    'UPDATE_PRODUCT',
    'UPDATE_PLAYER',
    'UPDATE_TEAM',
    'UPDATE_GOAL',
    'SET_CLIENT_KEY',
    'DELETE_CLIENT_KEY',
    'FETCH_GAME',
    'DELETE_GAME',
    'UPDATE_NOTIFICATION',
    'CHANGE_GAME_ACCOUNT_STATUS',
    'UPDATE_GAME_TRACKABLE_MAPPING',
    'UPDATE_USER_NOTIFICATIONS',
    'SET_USER_NOTIFICATIONS_LOADING',
    'SET_GAME_NOTIFICATIONS',
    'UPDATE_CLIENT_STORE'
];
export var ActionTypeSchema = z.enum(ActionTypeArray);
